import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams, Link } from "react-router-dom";
import BlogData from "./BlogData";
import "./ApkDetails.css";
import DeviceCompatibilityChecker from "./DeviceCompatibilityChecker";
import { supabase } from "../supabaseClient";
import NativeAd from "./NativeAd";
const API = "https://alpha-apk-backend.onrender.com";



// Amazon Affiliate Product Card Component
function AmazonProductCard({ category, appName, amazonData }) {
  const getProduct = () => {
    // Check if app has custom Amazon data from Supabase
    if (amazonData) {
      try {
        const custom = JSON.parse(amazonData);
        if (custom.link && custom.title) {
          return custom;
        }
      } catch (e) {
        console.log("Invalid amazon_data JSON:", amazonData);
      }
    }

    // Fallback by category
    const cat = category?.toLowerCase() || "";
    if (cat.includes("vpn")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61+3z1o4oZL._AC_SL1000_.jpg",title:`VPN Router for ${appName}`,desc:"Secure your home network with VPN support.",badge:"🔒 Privacy"};
    if (cat.includes("music")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61M8Z4Qa6YL._AC_SL1500_.jpg",title:"Wireless Earbuds",desc:"Premium sound for music streaming apps.",badge:"🎵 Music"};
    if (cat.includes("game")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61L1eOJ1vJL._AC_SL1500_.jpg",title:"Gaming Controller",desc:"Gamepad for Android gaming.",badge:"🎮 Gaming"};
    if (cat.includes("photo")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/71QZ0y7gPZL._AC_SL1500_.jpg",title:"Camera Lens Kit",desc:"Professional lenses for mobile photography.",badge:"📸 Photo"};
    if (cat.includes("file") || cat.includes("tool")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61dZ7d5q6JL._AC_SL1500_.jpg",title:"USB-C SD Reader",desc:"High-speed file transfer accessory.",badge:"📁 Storage"};
    if (cat.includes("video")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61h1hPJI+JL._AC_SL1500_.jpg",title:"Phone Stand",desc:"Hands-free video watching stand.",badge:"🎬 Video"};
    if (cat.includes("browser")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61vGQNQE+sL._AC_SL1000_.jpg",title:"Privacy Screen Protector",desc:"2-way privacy filter for public browsing.",badge:"🌐 Privacy"};
    if (cat.includes("social")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61Z4CjX+0nL._AC_SL1500_.jpg",title:"Ring Light for Selfies",desc:"Perfect lighting for Instagram and TikTok.",badge:"💬 Social"};
    if (cat.includes("education")) return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61Z4CjX+0nL._AC_SL1500_.jpg",title:"Tablet Stand for Study",desc:"Adjustable stand for online classes.",badge:"📚 Study"};

    return {link:"https://amzn.to/3SfD5Vf",image:"https://m.media-amazon.com/images/I/61Z4CjX+0nL._AC_SL1500_.jpg",title:"Power Bank 20000mAh",desc:"Fast charging for all Android devices.",badge:"📱 Essential"};
  };

  const product = getProduct();

  return (
    <div className="amazon-product-card">
      <div className="amazon-badge">{product.badge}</div>
      <div className="amazon-card-content">
        <img src={product.image} alt={product.title} loading="lazy" className="amazon-product-image" />
        <div className="amazon-product-info">
          <h3 className="amazon-product-title">{product.title}</h3>
          <p className="amazon-product-desc">{product.desc}</p>
          <a href={product.link} target="_blank" rel="noopener noreferrer" className="amazon-buy-btn">
            🛒 Buy on Amazon at Discount
          </a>
          <p className="amazon-disclaimer">*As an Amazon Associate, we earn from qualifying purchases.</p>
        </div>
      </div>
    </div>
  );
}

export default function ApkDetails() {
  const params = useParams();
  const slug = params.slug ? params.slug.trim().toLowerCase() : "";

  const [apk, setApk] = useState(null);
  const [allApks, setAllApks] = useState([]);
  const [loading, setLoading] = useState(true);

  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [commentUser, setCommentUser] = useState(null);
  const [helpfulCount, setHelpfulCount] = useState({ yes: 0, no: 0 });

  const [menuOpen, setMenuOpen] = useState(false);

  // Fetch single APK first, fallback to all APKs
  useEffect(() => {
    const fetchSingleApk = async () => {
      try {
        const res = await fetch(`${API}/api/apk/${slug}`, {
          method: "GET",
          headers: { Accept: "application/json" },
        });

        if (!res.ok) throw new Error("Single APK endpoint failed");

        const text = await res.text();
        const data = JSON.parse(text);
        setApk(data);
        setLoading(false);
        if (data) {
          document.title = `${data.name} APK Download for Android | Alpha APK Store`;
        }
      } catch (err) {
        console.log("Single APK fetch failed, falling back:", err);
        fetchAllApks();
      }
    };

    const fetchAllApks = () => {
      fetch(`${API}/api/apks`, {
        method: "GET",
        headers: { Accept: "application/json" },
      })
        .then(async (res) => {
          const text = await res.text();
          try {
            return JSON.parse(text);
          } catch (error) {
            console.log("APK DETAILS API returned non-JSON:", text);
            throw new Error("Backend returned HTML instead of JSON");
          }
        })
        .then((data) => {
          if (!Array.isArray(data)) {
            setApk(null);
            setAllApks([]);
            setLoading(false);
            return;
          }

          const foundApk = data.find((item) => {
            const itemSlug = item.slug ? item.slug.trim().toLowerCase() : "";
            return itemSlug === slug;
          });

          setApk(foundApk || null);
          setAllApks(data || []);
          setLoading(false);

          if (foundApk) {
            document.title = `${foundApk.name} APK Download for Android | Alpha APK Store`;
          }
        })
        .catch((err) => {
          console.log("DETAIL ERROR:", err);
          setApk(null);
          setLoading(false);
        });
    };

    fetchSingleApk();
  }, [slug]);

  // Load comments
  useEffect(() => {
    const loadComments = async () => {
      const { data: userData } = await supabase.auth.getUser();
      setCommentUser(userData?.user || null);

      const { data, error } = await supabase
        .from("apk_comments")
        .select("*")
        .eq("apk_slug", slug)
        .order("created_at", { ascending: false });

      if (!error) {
        setComments(data || []);
      }
    };

    if (slug) {
      loadComments();
    }
  }, [slug]);

  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    const { data } = await supabase.auth.getUser();
    const user = data?.user;

    if (!user) {
      alert("Please login first to post comment");
      return;
    }

    const { error } = await supabase.from("apk_comments").insert([
      {
        apk_slug: slug,
        user_id: user.id,
        user_email: user.email,
        user_name: user.user_metadata?.full_name || user.email,
        comment: newComment.trim(),
      },
    ]);

    if (error) {
      console.log("COMMENT ERROR:", error);
      alert("Comment failed");
      return;
    }

    setNewComment("");

    const { data: updatedComments } = await supabase
      .from("apk_comments")
      .select("*")
      .eq("apk_slug", slug)
      .order("created_at", { ascending: false });

    setComments(updatedComments || []);
  };

  const handleHelpful = (type) => {
    setHelpfulCount((prev) => ({
      ...prev,
      [type]: prev[type] + 1,
    }));
  };

  const handleReload = () => {
    window.location.reload();
  };

  if (loading) return <p className="status">Loading...</p>;

  // IMPROVED: Show proper 404 page instead of redirect
  if (!apk) {
    return (
      <div className="not-found">
        <Helmet>
          <title>App Not Found | Alpha APK Store</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <h1>App Not Found</h1>
        <p>The app you are looking for does not exist or has been removed.</p>
        <Link to="/" className="back-btn">Back to Home</Link>
      </div>
    );
  }

  const categoryType = apk.category?.toLowerCase() || "";
  const appName = apk.name || "This app";

// ===============================
// HUNARHUB SPECIAL DOWNLOAD
// ===============================
const HUNARHUB_SLUG =
  "hunarhub-india-freelancing-platform-freelancers-clients";

const HUNARHUB_NAME =
  "HunarHub: India's #1 Freelancing Platform for Freelancers & Clients";

const HUNARHUB_DOWNLOAD_URL =
  "https://github.com/Karn-web/hunarhub-website/releases/download/v1.0.0/HunarHub.apk";

// Detect HunarHub using both slug and Supabase name
const isHunarHub =
  slug === HUNARHUB_SLUG ||
  appName.trim().toLowerCase() === HUNARHUB_NAME.trim().toLowerCase();

// Real download URL for this app
const realDownloadUrl = isHunarHub
  ? HUNARHUB_DOWNLOAD_URL
  : apk.download_url;

  // Clean app name extraction
  const cleanAppName = appName
    .replace(/APK Download Latest Version for Android Free/gi, "")
    .replace(/APK Download Latest Version for Android/gi, "")
    .replace(/APK Download for Android/gi, "")
    .replace(/Download Latest Version for Android/gi, "")
    .replace(/Latest Version/gi, "")
    .replace(/Free/gi, "")
    .replace(/APK/gi, "")
    .replace(/\|/g, "")
    .replace(/\s+/g, " ")
    .trim() || appName;

  const categorySlug = apk.category
    ? apk.category.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")
    : "apps";

  const pageUrl = `https://www.alphaapkstore.com/apk/${apk.slug}`;

  // Meta description
  const shortSeoDescription = `Download ${cleanAppName} APK for Android. View version ${apk.version || "Latest"}, file size ${apk.size || "N/A"}, permissions, screenshots, compatibility details, safety information, and install guide on Alpha APK Store.`;

  const formatHash = (hash) => {
    if (!hash) return "Not added yet";
    const cleanHash = String(hash).trim();
    if (cleanHash.length <= 24) return cleanHash;
    return `${cleanHash.slice(0, 18)}...${cleanHash.slice(-12)}`;
  };

  const copyToClipboard = async (value) => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      alert("SHA256 copied");
    } catch (error) {
      console.log("COPY FAILED:", error);
      alert("Copy failed. Please copy manually.");
    }
  };

  // Content variants
  const getContentVariant = () => {
    if (categoryType.includes("vpn")) return "vpn";
    if (categoryType.includes("music")) return "music";
    if (categoryType.includes("game")) return "game";
    if (categoryType.includes("education") || categoryType.includes("learning")) return "education";
    if (categoryType.includes("photo") || categoryType.includes("gallery") || categoryType.includes("camera")) return "photo";
    if (categoryType.includes("file") || categoryType.includes("manager") || categoryType.includes("utility")) return "file";
    if (categoryType.includes("security") || appName.toLowerCase().includes("bitwarden")) return "security";
    if (categoryType.includes("ai") || appName.toLowerCase().includes("gemini")) return "ai";
    if (categoryType.includes("social") || categoryType.includes("media")) return "social";
    if (categoryType.includes("tool")) return "tools";
    if (categoryType.includes("video") || categoryType.includes("player")) return "video";
    if (categoryType.includes("browser") || categoryType.includes("web")) return "browser";
    return "general";
  };

  const variant = getContentVariant();

  const contentVariants = {
    vpn: {
      sections: [
        {
          title: `${cleanAppName} Privacy & Security Features`,
          text: `${cleanAppName} provides encrypted VPN tunneling for Android users. It helps protect data on public Wi-Fi networks and can mask your IP address for private browsing. Users should verify server locations and logging policies before trusting any VPN service.`
        },
        {
          title: `When to Use ${cleanAppName}`,
          text: `Use ${cleanAppName} when connecting to public Wi-Fi at cafes, airports, or hotels. It can also help access geo-restricted content. However, no free VPN replaces comprehensive security practices — always combine with HTTPS websites and avoid sharing sensitive data on untrusted networks.`
        },
        {
          title: `Performance Expectations`,
          text: `VPN apps typically reduce connection speed by 10-30% due to encryption overhead. ${cleanAppName} performance varies by server distance, network congestion, and your device hardware. Test multiple servers for best results.`
        }
      ],
      pros: [
        "Encrypts traffic on public Wi-Fi",
        "Hides IP address from websites",
        "Can bypass regional restrictions"
      ],
      cons: [
        "May reduce internet speed",
        "Free servers often have limits",
        "Logging policies vary by provider"
      ],
      faq: [
        {
          question: `Does ${cleanAppName} keep logs of my browsing?`,
          answer: `Check the app's privacy policy. Free VPNs often collect anonymized data for ads. ${cleanAppName} is listed for informational purposes — verify logging claims independently.`
        },
        {
          question: `Can ${cleanAppName} unblock streaming services?`,
          answer: `Some VPNs bypass geo-blocks, but streaming platforms actively detect and block VPN IPs. Results vary daily. This page does not guarantee unblocking capability.`
        },
        {
          question: `Is ${cleanAppName} safe for banking apps?`,
          answer: `We do not recommend using any free VPN for banking or financial transactions. Use your bank's official app on secure home networks instead.`
        }
      ]
    },

    music: {
      sections: [
        {
          title: `${cleanAppName} Audio Experience`,
          text: `${cleanAppName} offers music streaming, playlist management, and offline playback features for Android. Audio quality ranges from 128kbps to 320kbps depending on settings and connection. Check if the app supports your preferred audio format.`
        },
        {
          title: `Offline Listening & Data Usage`,
          text: `Download songs for offline playback to save mobile data. A 3-minute song at 320kbps uses approximately 7.5 MB. ${cleanAppName} may offer quality settings to balance audio fidelity against data consumption.`
        },
        {
          title: `Library & Discovery Features`,
          text: `Explore the app's catalog size, genre diversity, and recommendation algorithm. Some apps focus on mainstream hits while others specialize in indie, classical, or regional music. Verify if your favorite artists are available before committing.`
        }
      ],
      pros: [
        "Access to large music catalogs",
        "Offline playback saves data",
        "Personalized recommendations"
      ],
      cons: [
        "Audio quality varies by plan",
        "Some tracks region-locked",
        "Offline downloads use storage"
      ],
      faq: [
        {
          question: `Does ${cleanAppName} work offline?`,
          answer: `Most music apps allow offline downloads with a premium or free tier limit. Check the app's specific offline policy in its settings.`
        },
        {
          question: `What audio quality does ${cleanAppName} support?`,
          answer: `Quality varies by app version and settings. Common options are 128kbps, 256kbps, or 320kbps. Higher quality uses more data and storage.`
        },
        {
          question: `Can I transfer my playlists to ${cleanAppName}?`,
          answer: `Some apps support playlist imports from Spotify, YouTube Music, or Apple Music. Check the app's FAQ or settings for import tools.`
        }
      ]
    },

    game: {
      sections: [
        {
          title: `${cleanAppName} Gameplay Overview`,
          text: `${cleanAppName} runs on Android devices with varying performance based on hardware. Casual games typically need 2GB RAM; graphics-intensive titles require 4GB+. Check the specific Android version and GPU requirements before installing.`
        },
        {
          title: `Controls & User Interface`,
          text: `Touch controls, gesture support, and controller compatibility vary by game. ${cleanAppName} may support Bluetooth controllers or on-screen buttons. Test the control scheme in the first 10 minutes of play.`
        },
        {
          title: `Progression & Monetization`,
          text: `Free games often include ads, energy systems, or in-app purchases. ${cleanAppName} may offer optional purchases for cosmetics, power-ups, or ad removal. Set spending limits in Google Play settings if needed.`
        }
      ],
      pros: [
        "Entertainment during commutes",
        "Many genres available free",
        "Offline play on some titles"
      ],
      cons: [
        "May include ads or IAPs",
        "Battery drain during long sessions",
        "Large file sizes for HD games"
      ],
      faq: [
        {
          question: `Does ${cleanAppName} need internet?`,
          answer: `Single-player games often work offline. Multiplayer, leaderboards, or cloud saves require internet. Check the app's description for offline capability.`
        },
        {
          question: `Can I play ${cleanAppName} with a controller?`,
          answer: `Android supports Bluetooth controllers (Xbox, PS4/5, generic). Check the game's settings for controller mapping options.`
        },
        {
          question: `Will ${cleanAppName} work on my phone?`,
          answer: `Compare your phone's RAM, Android version, and GPU against the app's requirements. Use our device checker below the download button.`
        }
      ]
    },

    education: {
      sections: [
        {
          title: `${cleanAppName} Learning Approach`,
          text: `${cleanAppName} provides educational content through video lessons, interactive quizzes, or reading materials. Verify the curriculum alignment with your goals — test prep, language learning, or skill development.`
        },
        {
          title: `Offline Study & Progress Tracking`,
          text: `Download lessons for offline study during commutes. ${cleanAppName} may track your progress, streaks, or quiz scores. Export progress data if you plan to switch apps later.`
        },
        {
          title: `Age Appropriateness & Content Quality`,
          text: `Check the target age range and content rating. Educational apps for children should have COPPA compliance. Higher-education apps should cite credible sources and offer certificates if applicable.`
        }
      ],
      pros: [
        "Learn at your own pace",
        "Often cheaper than courses",
        "Progress tracking motivates consistency"
      ],
      cons: [
        "Quality varies by creator",
        "Certificates may not be accredited",
        "Requires self-discipline"
      ],
      faq: [
        {
          question: `Is ${cleanAppName} free for all content?`,
          answer: `Many education apps offer free basics with premium advanced content. Check the pricing structure before starting a learning path.`
        },
        {
          question: `Can I download lessons for offline use?`,
          answer: `Most apps allow offline downloads for subscribed or free content. Check storage requirements — video lessons can exceed 100 MB each.`
        },
        {
          question: `Does ${cleanAppName} offer certificates?`,
          answer: `Certificates vary by platform. Some are free completion badges; others require payment and identity verification. Check accreditation status if you need formal recognition.`
        }
      ]
    },

    photo: {
      sections: [
        {
          title: `${cleanAppName} Editing Capabilities`,
          text: `${cleanAppName} offers photo editing tools ranging from basic filters to advanced layer-based editing. Check supported formats (JPEG, PNG, RAW) and maximum resolution limits before importing large files.`
        },
        {
          title: `Export Quality & Watermarks`,
          text: `Free photo editors may add watermarks or limit export resolution. ${cleanAppName} might offer 1080p exports for free and 4K for premium. Verify export settings before editing important photos.`
        },
        {
          title: `Privacy & Cloud Storage`,
          text: `Photo apps may upload images to cloud servers for AI processing. ${cleanAppName} should clarify whether your photos stay local or are processed remotely. Review privacy settings before granting gallery access.`
        }
      ],
      pros: [
        "Edit photos without desktop software",
        "Filters and effects for quick sharing",
        "Some apps support RAW editing"
      ],
      cons: [
        "Advanced features often paid",
        "May compress images on export",
        "Cloud processing raises privacy concerns"
      ],
      faq: [
        {
          question: `Does ${cleanAppName} support RAW files?`,
          answer: `RAW support varies by app. Professional editors usually support RAW; casual apps may only handle JPEG and PNG. Check the import dialog.`
        },
        {
          question: `Will ${cleanAppName} add watermarks?`,
          answer: `Many free apps add watermarks to exports. Look for "Remove watermark" in settings or consider the premium tier for clean exports.`
        },
        {
          question: `Are my photos uploaded to the cloud?`,
          answer: `Check the app's privacy policy. Some process photos locally; others use cloud AI. Disable cloud features in settings if you prefer local-only editing.`
        }
      ]
    },

    file: {
      sections: [
        {
          title: `${cleanAppName} Archive & File Support`,
          text: `${cleanAppName} handles compressed archives (ZIP, RAR, 7Z) and file management. Verify supported formats — some apps extract but cannot create certain archive types. Check encryption support for password-protected files.`
        },
        {
          title: `Storage Management & Cleanup`,
          text: `File managers help identify large files, duplicates, and cache data. ${cleanAppName} may include storage analyzers or batch rename tools. Use these features monthly to prevent storage bloat.`
        },
        {
          title: `Root Access & Advanced Features`,
          text: `Some file managers offer root access for system-level file editing. ${cleanAppName} does not require root for standard use. Only enable root if you understand the security risks and have backups.`
        }
      ],
      pros: [
        "Manage files without PC connection",
        "Extract archives on mobile",
        "Find and delete large files easily"
      ],
      cons: [
        "May request broad storage permissions",
        "Root features risk system stability",
        "Complex interfaces confuse beginners"
      ],
      faq: [
        {
          question: `Can ${cleanAppName} open password-protected ZIPs?`,
          answer: `Most modern file managers support password-protected ZIP and RAR files. 7Z encryption support varies — check the app's format list.`
        },
        {
          question: `Does ${cleanAppName} need root access?`,
          answer: `No root is needed for standard file management. Root access is only for editing system files — avoid unless you're an advanced user.`
        },
        {
          question: `Can I transfer files to PC with ${cleanAppName}?`,
          answer: `Many file managers include FTP server or Wi-Fi transfer features. Check the app's tools menu for PC connection options.`
        }
      ]
    },

    security: {
      sections: [
        {
          title: `${cleanAppName} Security Model`,
          text: `${cleanAppName} protects passwords, sensitive data, or device access. Verify the encryption standard (AES-256, ChaCha20) and whether data is stored locally or synced to cloud servers.`
        },
        {
          title: `Two-Factor Authentication & Backup`,
          text: `Enable 2FA if available. ${cleanAppName} should offer encrypted backup options for your vault or settings. Store recovery codes offline in a secure physical location.`
        },
        {
          title: `Open Source & Audit Status`,
          text: `Open-source security apps allow independent code audits. ${cleanAppName} — check if the source code is published on GitHub and whether security researchers have reviewed it.`
        }
      ],
      pros: [
        "Protects passwords and sensitive data",
        "Can generate strong random passwords",
        "Alerts for breached accounts"
      ],
      cons: [
        "Master password loss = data loss",
        "Cloud sync requires trust in provider",
        "Some features require subscription"
      ],
      faq: [
        {
          question: `What happens if I forget my master password?`,
          answer: `Most security apps cannot recover master passwords by design. Set up emergency contacts or backup keys during initial setup.`
        },
        {
          question: `Is ${cleanAppName} open source?`,
          answer: `Check the developer's GitHub or website. Open-source apps allow community security audits. Closed-source apps rely on the company's internal security team.`
        },
        {
          question: `Can I use ${cleanAppName} on multiple devices?`,
          answer: `Most security apps support sync across Android, iOS, and desktop via encrypted cloud. Verify sync is end-to-end encrypted before enabling.`
        }
      ]
    },

    ai: {
      sections: [
        {
          title: `${cleanAppName} AI Capabilities`,
          text: `${cleanAppName} uses machine learning for tasks like text generation, image creation, or voice recognition. AI models run either on-device (privacy-friendly, slower) or via cloud API (faster, requires internet).`
        },
        {
          title: `Data Privacy & Training`,
          text: `Check whether your inputs train the AI model. ${cleanAppName} should clarify data retention policies. Avoid entering personal information, passwords, or confidential documents into AI tools.`
        },
        {
          title: `Accuracy & Limitations`,
          text: `AI can hallucinate incorrect information. ${cleanAppName} outputs should be fact-checked for critical decisions. Use AI for drafting and brainstorming, not final legal, medical, or financial advice.`
        }
      ],
      pros: [
        "Automates repetitive writing tasks",
        "Can generate creative ideas quickly",
        "Some features work offline"
      ],
      cons: [
        "May produce incorrect information",
        "Privacy concerns with cloud AI",
        "Requires fact-checking for accuracy"
      ],
      faq: [
        {
          question: `Does ${cleanAppName} work offline?`,
          answer: `On-device AI works offline but is less powerful. Cloud AI needs internet and may send your inputs to remote servers. Check the app's settings for offline mode.`
        },
        {
          question: `Can I trust ${cleanAppName} for medical or legal advice?`,
          answer: `No AI app should replace professional advice. Use outputs as starting points only. Always consult qualified professionals for medical, legal, or financial decisions.`
        },
        {
          question: `Does ${cleanAppName} store my conversations?`,
          answer: `Storage policies vary. Some apps delete chats immediately; others retain them for model improvement. Review the privacy policy before sharing sensitive topics.`
        }
      ]
    },

    social: {
      sections: [
        {
          title: `${cleanAppName} Communication Features`,
          text: `${cleanAppName} enables messaging, calling, or community interaction. Check supported formats — text, voice, video, or file sharing. End-to-end encryption status varies by platform.`
        },
        {
          title: `Privacy Settings & Data Collection`,
          text: `Social apps collect contact lists, location, and usage patterns. ${cleanAppName} should offer granular privacy controls. Disable unnecessary permissions in Android settings after installation.`
        },
        {
          title: `Cross-Platform Availability`,
          text: `Check if ${cleanAppName} syncs with desktop or web versions. Multi-platform support ensures you can continue conversations across devices without message loss.`
        }
      ],
      pros: [
        "Stay connected with friends and groups",
        "Free messaging and calls over Wi-Fi",
        "Share media and documents easily"
      ],
      cons: [
        "Heavy battery and data usage",
        "Privacy risks with personal data",
        "Notification overload possible"
      ],
      faq: [
        {
          question: `Is ${cleanAppName} end-to-end encrypted?`,
          answer: `Encryption policies vary. Some apps encrypt all messages; others only in "secret" chats. Check the app's security settings for encryption status.`
        },
        {
          question: `Can I use ${cleanAppName} without a phone number?`,
          answer: `Some apps require phone numbers; others use email or usernames. Check registration options if you prefer not to share your number.`
        },
        {
          question: `Does ${cleanAppName} sell my data?`,
          answer: `Review the privacy policy. Free social apps often monetize through ads based on usage data. Some offer paid tiers with reduced data collection.`
        }
      ]
    },

    tools: {
      sections: [
        {
          title: `${cleanAppName} Utility Functions`,
          text: `${cleanAppName} provides specific utility functions for Android users. Identify your primary need — calculation, measurement, conversion, or system monitoring — and verify the app covers it comprehensively.`
        },
        {
          title: `Accuracy & Calibration`,
          text: `Tools like levelers, speedometers, or sound meters rely on device sensors. ${cleanAppName} accuracy depends on your phone's hardware quality. Cross-check critical measurements with dedicated devices.`
        },
        {
          title: `Widget & Shortcut Support`,
          text: `Home screen widgets provide quick access to tool functions. ${cleanAppName} may offer customizable widgets. Check if widgets update in real-time or require manual refresh.`
        }
      ],
      pros: [
        "Replaces multiple single-purpose apps",
        "Quick access via widgets",
        "Often lightweight and battery-efficient"
      ],
      cons: [
        "Sensor accuracy varies by device",
        "Advanced features may need premium",
        "Some tools require frequent calibration"
      ],
      faq: [
        {
          question: `How accurate is ${cleanAppName}?`,
          answer: `Accuracy depends on your phone's sensors. For professional use, compare results with dedicated hardware tools.`
        },
        {
          question: `Does ${cleanAppName} have a home screen widget?`,
          answer: `Many utility apps offer widgets. Long-press your home screen and check the widgets menu for ${cleanAppName} options.`
        },
        {
          question: `Can I use ${cleanAppName} offline?`,
          answer: `Most utility tools work fully offline. Apps requiring live data (currency converters, weather tools) need periodic internet access.`
        }
      ]
    },

    video: {
      sections: [
        {
          title: `${cleanAppName} Playback Features`,
          text: `${cleanAppName} supports video playback with various format compatibility. Check supported codecs (H.264, H.265, VP9) and subtitle formats (SRT, ASS, VTT) before relying on it for your media library.`
        },
        {
          title: `Streaming vs Local Playback`,
          text: `Some video apps stream from online sources; others play local files only. ${cleanAppName} — verify whether it requires internet or works with files stored on your device or SD card.`
        },
        {
          title: `Hardware Acceleration & Battery`,
          text: `Hardware decoding reduces battery drain during video playback. ${cleanAppName} should use your phone's GPU for 1080p+ content. Disable software decoding if you experience stuttering or overheating.`
        }
      ],
      pros: [
        "Plays multiple video formats",
        "Hardware decoding saves battery",
        "Subtitle and audio track support"
      ],
      cons: [
        "Some codecs need separate downloads",
        "4K playback may stutter on old phones",
        "Streaming apps use significant data"
      ],
      faq: [
        {
          question: `What video formats does ${cleanAppName} support?`,
          answer: `Common formats include MP4, MKV, AVI, and FLV. Codec support (H.264, H.265, AV1) varies by app version and device hardware.`
        },
        {
          question: `Can ${cleanAppName} play 4K videos?`,
          answer: `4K playback requires both app support and capable hardware. Phones with Snapdragon 7-series or better typically handle 4K smoothly.`
        },
        {
          question: `Does ${cleanAppName} support subtitles?`,
          answer: `Most video players support SRT and ASS subtitles. Some auto-download subtitles from online databases. Check the subtitle settings menu.`
        }
      ]
    },

    browser: {
      sections: [
        {
          title: `${cleanAppName} Browsing Features`,
          text: `${cleanAppName} offers web browsing with features like tab management, ad blocking, or privacy modes. Check the rendering engine — Chromium-based browsers generally have best compatibility; Gecko-based prioritize privacy.`
        },
        {
          title: `Privacy & Tracking Protection`,
          text: `Built-in ad blockers and tracker blockers reduce data usage and load times. ${cleanAppName} may offer "strict" or "balanced" blocking modes. Test both to find your preferred trade-off between functionality and privacy.`
        },
        {
          title: `Sync & Cross-Device Support`,
          text: `Bookmark and password sync requires an account. ${cleanAppName} — check if sync is encrypted end-to-end. Avoid syncing passwords to browsers without strong master password protection.`
        }
      ],
      pros: [
        "Faster than stock browser with ad blocking",
        "Privacy modes don't save history",
        "Extensions add functionality"
      ],
      cons: [
        "Some sites block ad-blocking browsers",
        "Sync features require account creation",
        "Privacy modes don't make you anonymous"
      ],
      faq: [
        {
          question: `Does ${cleanAppName} block ads?`,
          answer: `Many alternative browsers include ad blocking. Check the settings menu for "Content blocking" or "Ad blocker" options.`
        },
        {
          question: `Is ${cleanAppName} more private than Chrome?`,
          answer: `Privacy depends on settings. Browsers with tracker blocking and no Google integration are generally more private. But no browser provides complete anonymity without additional tools.`
        },
        {
          question: `Can I sync bookmarks with my PC?`,
          answer: `Most browsers offer sync via account. Check if the desktop version exists and whether sync is encrypted before enabling.`
        }
      ]
    },

    general: {
      sections: [
        {
          title: `${cleanAppName} Core Functionality`,
          text: `${cleanAppName} provides specific utility for Android users. Review the app's primary purpose — whether productivity, entertainment, or system enhancement — and verify it matches your needs before downloading.`
        },
        {
          title: `Performance & Resource Usage`,
          text: `Check RAM and battery consumption during typical use. ${cleanAppName} should not cause overheating or excessive background activity. Monitor battery usage in Android Settings > Battery after installation.`
        },
        {
          title: `Updates & Long-Term Support`,
          text: `Verify the app's update frequency and developer responsiveness. ${cleanAppName} — check the last update date. Apps without updates for 12+ months may have compatibility issues with newer Android versions.`
        }
      ],
      pros: [
        "Fills a specific Android need",
        "Regular updates improve stability",
        "Lightweight alternatives save battery"
      ],
      cons: [
        "May overlap with built-in Android features",
        "Niche apps have smaller support communities",
        "Compatibility varies by Android version"
      ],
      faq: [
        {
          question: `What does ${cleanAppName} do?`,
          answer: `Review the app's description and screenshots above. Each app serves a specific purpose — verify it matches your needs before installing.`
        },
        {
          question: `Is ${cleanAppName} safe to install?`,
          answer: `We provide package name, developer info, SHA256 hash, and scan date for verification. Always review permissions and scan with your own antivirus before installing any APK.`
        },
        {
          question: `When was ${cleanAppName} last updated?`,
          answer: `The update date is shown in the meta box above. Apps updated within 6 months are generally more compatible with current Android versions.`
        }
      ]
    }
  };

  const baseContent = contentVariants[variant] || contentVariants.general;

  const parseList = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return String(value)
        .split("\n")
        .map((item) => item.trim())
        .filter(Boolean);
    }
  };

  const normalizeFaq = (value) => {
    const faqItems = parseList(value);
    return faqItems
      .map((item) => {
        if (typeof item === "string") {
          return {
            question: item,
            answer: `${cleanAppName} is listed on Alpha APK Store with verified package details, SHA256 hash, scan date, and compatibility information. Users should always review permissions and verify the developer before installing any APK.`
          };
        }
        return {
          question: item.question || item.name || `Is ${cleanAppName} safe to install?`,
          answer:
            item.answer ||
            item.acceptedAnswer?.text ||
            `${cleanAppName} is listed with package name ${apk.package_name || "verified"}, developer ${apk.developer || "listed"}, and SHA256 hash for verification. Always check permissions before installing.`
        };
      })
      .filter((item) => item.question && item.answer);
  };

  const customFeatures = parseList(apk.features);
  const customPros = parseList(apk.pros);
  const customCons = parseList(apk.cons);
  const customFaq = normalizeFaq(apk.faq);
  const customHowToInstall = parseList(apk.how_to_install);

  const selectedContent = {
    ...baseContent,
    sections: [
      ...(apk.overview_text
        ? [
            {
              title: apk.overview_title || `${cleanAppName} Overview`,
              text: apk.overview_text
            }
          ]
        : []),
      ...(apk.expert_review
        ? [
            {
              title: `Alpha APK Review of ${cleanAppName}`,
              text: apk.expert_review
            }
          ]
        : []),
      ...baseContent.sections
    ],
    features: customFeatures.length ? customFeatures : [],
    pros: customPros.length ? customPros : baseContent.pros,
    cons: customCons.length ? customCons : baseContent.cons,
    faq: customFaq.length ? customFaq : baseContent.faq,
    howToInstall: customHowToInstall.length
      ? customHowToInstall
      : [
          `Review ${cleanAppName} details on this page — version, permissions, screenshots, and compatibility.`,
          "Click the official source button — Google Play Store, GitHub, or F-Droid.",
          "Install directly from the official source for maximum security and auto-updates.",
          `Open ${cleanAppName} and verify it works correctly on your device.`
        ]
  };

  const relatedApks = allApks
    .filter((item) => item.category === apk.category && item.slug !== apk.slug)
    .slice(0, 4);

  const fallbackRelatedApks = allApks
    .filter((item) => item.slug !== apk.slug)
    .slice(0, 4);

  const finalRelatedApks =
    relatedApks.length > 0 ? relatedApks : fallbackRelatedApks;

  const formattedDescription = apk.description
    ? apk.description.split(". ").join(".\n\n")
    : "No description available.";

  const relatedBlogs = BlogData.slice(0, 3);

  const getScreenshotList = () => {
    if (!apk.screenshots) return [];
    if (Array.isArray(apk.screenshots)) {
      return apk.screenshots.filter(Boolean);
    }
    try {
      const parsed = JSON.parse(apk.screenshots);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  };

  const screenshotList = getScreenshotList();

  const permissionList = apk.permissions
    ? String(apk.permissions)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
    : [];

  const getPermissionMeaning = (permission) => {
    const value = permission.toLowerCase();
    if (value.includes("camera")) {
      return "Used for camera-based features such as scanning, capturing images, or visual tools when supported by the app.";
    }
    if (value.includes("microphone")) {
      return "Used for voice input, audio recording, calls, translation, or communication features when supported by the app.";
    }
    if (value.includes("storage") || value.includes("media")) {
      return "Used for reading, saving, organizing, or managing files, downloads, photos, videos, or app data on Android.";
    }
    if (value.includes("network") || value.includes("internet")) {
      return "Used for online features, updates, content loading, account sync, downloads, or server connection.";
    }
    if (value.includes("notification")) {
      return "Used to show alerts, updates, reminders, messages, or app activity notifications.";
    }
    if (value.includes("location") || value.includes("gps")) {
      return "Used for maps, nearby services, navigation, location-based tools, or personalized results when enabled.";
    }
    if (value.includes("vpn")) {
      return "Used to create a secure VPN tunnel and route internet traffic through the app connection.";
    }
    if (value.includes("system")) {
      return "Used for advanced Android utility features that may need extra device-level access.";
    }
    if (value.includes("contact") || value.includes("phone")) {
      return "Used to access contacts or phone functions for communication features. Review carefully before granting.";
    }
    if (value.includes("sms") || value.includes("message")) {
      return "Used for text messaging features. Verify the app genuinely needs this before installing.";
    }
    if (value.includes("bluetooth")) {
      return "Used for connecting to Bluetooth devices, file transfers, or wireless accessories.";
    }
    if (value.includes("calendar")) {
      return "Used to read or modify calendar events. Ensure the app has a legitimate scheduling purpose.";
    }
    return "Used for app features related to this permission. Review this permission before installing.";
  };

  const hasCoreSafetyDetails = Boolean(
    apk.package_name && apk.android_requirement && apk.permissions && apk.size && apk.developer
  );

  const securityRating = hasCoreSafetyDetails
    ? "Reviewed — App details verified from official sources"
    : "Needs Review — Some app details are missing";

  const bigBrandKeywords = [
    "google", "spotify", "reddit", "instagram", "facebook",
    "vlc", "khan academy", "photomath", "soundcloud", "opera",
    "maps", "youtube", "twitter", "whatsapp", "telegram",
    "microsoft", "adobe"
  ];

  const isBigBrandApp = bigBrandKeywords.some((brand) =>
    appName.toLowerCase().includes(brand)
  );

  const alternativeApks = allApks
    .filter((item) => item.category === apk.category && item.slug !== apk.slug)
    .slice(0, 3);

  const displayRating = apk.rating && parseFloat(apk.rating) > 0 ? parseFloat(apk.rating) : null;

  // FAQ Schema
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: selectedContent.faq.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer
      }
    }))
  };

  // Breadcrumb Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.alphaapkstore.com/"
      },
      {
        "@type": "ListItem",
        position: 2,
        name: apk.category || "Android Apps",
        item: `https://www.alphaapkstore.com/${categorySlug}`
      },
      {
        "@type": "ListItem",
        position: 3,
        name: `${cleanAppName} APK`,
        item: pageUrl
      }
    ]
  };

  // HowTo Schema
  const howToSchema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: `How to install ${cleanAppName} APK on Android`,
    description: `Step-by-step guide to install ${cleanAppName} APK safely on Android after checking version, size, permissions, and compatibility details.`,
    totalTime: "PT5M",
    supply: [
      { "@type": "HowToSupply", name: "Android phone or tablet" },
      { "@type": "HowToSupply", name: `${cleanAppName} APK file` }
    ],
    step: selectedContent.howToInstall.map((step, index) => {
      const stepNames = [
        "Review App Details",
        "Check Compatibility",
        "Download APK File",
        "Install and Verify"
      ];
      return {
        "@type": "HowToStep",
        position: index + 1,
        name: stepNames[index] || `Step ${index + 1}`,
        text: step
      };
    })
  };

  // SoftwareApplication Schema — WITH aggregateRating & review
  const appSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: `${cleanAppName} APK`,
    alternateName: appName,
    operatingSystem: apk.android_requirement || "Android 5.0+",
    applicationCategory: apk.category || "Android App",
    applicationSubCategory: apk.category || "Android App",
    softwareVersion: apk.version || "Latest",
    fileSize: apk.size || "N/A",
    image: apk.image_url || "https://www.alphaapkstore.com/logo.png",
    screenshot: screenshotList.map((img) => ({
      "@type": "ImageObject",
      url: img
    })),
    featureList:
      selectedContent.features.length > 0
        ? selectedContent.features
        : selectedContent.pros,
    description: apk.meta_description || shortSeoDescription,
    url: pageUrl,
    inLanguage: "en",
    datePublished: apk.created_at || new Date().toISOString(),
    dateModified: apk.updated_date || apk.created_at || new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Alpha APK Store",
      url: "https://www.alphaapkstore.com/"
    },
    publisher: {
      "@type": "Organization",
      name: "Alpha APK Store",
      logo: {
        "@type": "ImageObject",
        url: "https://www.alphaapkstore.com/logo.png"
      }
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      url: pageUrl
    },
    aggregateRating: displayRating
      ? {
          "@type": "AggregateRating",
          ratingValue: displayRating.toFixed(1),
          reviewCount: comments.length || 1,
          bestRating: 5,
          worstRating: 1
        }
      : undefined,
    review: comments.slice(0, 5).map((c) => ({
      "@type": "Review",
      author: {
        "@type": "Person",
        name: c.user_name || "Anonymous"
      },
      reviewBody: c.comment,
      datePublished: c.created_at
    }))
  };

  return (
    <div className="apk-detail">
      <Helmet>
        <title>{cleanAppName} APK Download for Android | Alpha APK Store</title>
        <meta name="description" content={shortSeoDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={`${cleanAppName} APK Download for Android | Alpha APK Store`} />
        <meta property="og:description" content={shortSeoDescription} />
        <meta property="og:image" content={apk.image_url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${cleanAppName} APK Download for Android | Alpha APK Store`} />
        <meta name="twitter:description" content={shortSeoDescription} />
        <meta name="twitter:image" content={apk.image_url} />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(appSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>

      <div className="detail-topbar">
        <div className="left-actions">
          <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </button>
          <Link to="/" className="back-btn">← Back</Link>
        </div>
        <Link to="/" className="admin-btn">Home</Link>
      </div>

      {menuOpen && (
        <div className="side-menu">
          <Link to="/">Home</Link>
          <button onClick={handleReload}>Reload Site</button>
          <a href="#related">Trending Apps</a>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/blog">Blog</Link>
        </div>
      )}

      <div className="breadcrumb">
        <Link to="/">Home</Link> /{" "}
        <Link to={`/${apk.category?.toLowerCase()}`}>{apk.category}</Link> /{" "}
        <span>{cleanAppName}</span>
      </div>

      <div className="apk-header">
        <img
          src={apk.image_url}
          alt={cleanAppName}
          loading="eager"
          width="240"
          height="240"
        />
        <div>
          <h1>{cleanAppName}</h1>
          <p>{apk.category}</p>
          <p className="author-line">
            Reviewed by Alpha APK Team • Owner: KARANDEEP SINGH SANDHU
          </p>
          <p className="author-line">
            Last Updated: {apk.updated_date || "Recently"}
          </p>
         {isHunarHub ? (
            <a
              href={HUNARHUB_DOWNLOAD_URL}
              className="download-btn hunarhub-real-download"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              ⬇️ Download APK
            </a>
          ) : (
            <button
              className="download-btn scroll-to-download"
              onClick={() => {
                document
                  .getElementById("download")
                  ?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
              }}
            >
              ⬇️ Download APK
            </button>
          )} 
        </div>
      </div>

      <div className="meta-box">
        <div>
          <strong>Updated</strong>
          <br />
          {apk.updated_date || "Recently"}
        </div>
        {displayRating ? (
          <div>
            <strong>Rating</strong>
            <br />⭐ {displayRating.toFixed(1)} ({comments.length} reviews)
          </div>
        ) : (
          <div>
            <strong>Downloads</strong>
            <br />📥 Verified
          </div>
        )}
      </div>

      <div className="safe-box safety-check-box">
        <div className="verified-badge">✓ Alpha Safety Check</div>
        <h2>Alpha Safety Check for {cleanAppName}</h2>

        <div className="app-info-item">
          <strong>Security Rating</strong>
          <p>{securityRating}</p>
        </div>

        <div className="check-item">
          ✅ Package Name: {apk.package_name || "Not Available"}
        </div>
        <div className="check-item">
          ✅ Android Requirement: {apk.android_requirement || "Android 5.0+"}
        </div>
        <div className="check-item">✅ File Size: {apk.size || "N/A"}</div>
        <div className="check-item">
          ✅ Developer Listed: {apk.developer || "Unknown Developer"}
        </div>
        <div className="check-item">
          ✅ Permissions Reviewed: {apk.permissions || "Standard App Permissions"}
        </div>

        {apk.virustotal_url && (
          <div className="check-item">
            ✅{" "}
            <a href={apk.virustotal_url} target="_blank" rel="noopener noreferrer">
              VirusTotal Scan: {apk.virustotal_result || "View Report"}
            </a>
          </div>
        )}

        <p>
          Alpha APK Store verifies package name, developer information, file size,
          permissions, Android requirement, screenshots, and update notes before
          listing an APK page. We scan files with VirusTotal when possible.
        </p>
      </div>

      <NativeAd />

      {permissionList.length > 0 && (
        <div className="app-info-box permission-analysis-box">
          <h2>Permission Analysis</h2>
          {permissionList.map((permission, index) => (
            <div className="app-info-item" key={index}>
              <strong>{permission}</strong>
              <p>{getPermissionMeaning(permission)}</p>
            </div>
          ))}
        </div>
      )}

      <div className="app-info-box compatibility-summary-box">
        <h2>Compatibility Summary</h2>
        <div className="app-info-item">
          <strong>Android Support</strong>
          <p>{apk.android_requirement || "Android 5.0+"}</p>
        </div>
        <div className="app-info-item">
          <strong>Storage Needed</strong>
          <p>{apk.size || "Check file size before installing"}</p>
        </div>
        <div className="app-info-item">
          <strong>Root Requirement</strong>
          <p>
            Root is not required unless the app itself clearly mentions advanced
            system features.
          </p>
        </div>
        <div className="app-info-item">
          <strong>APK Transparency Note</strong>
          <p>
            Alpha APK Store verifies package name, developer information, file size,
            permissions, Android requirement, screenshots, and update notes before
            listing an app page. We link only to official sources — Google Play Store,
            GitHub Releases, F-Droid, and verified developer websites.
          </p>
        </div>
      </div>

      {isBigBrandApp && (
        <div className="safe-box">
          <div className="verified-badge">Important Notice</div>
          <h2>Official App Ownership Notice</h2>
          <p>
            {cleanAppName} is listed for Android information, compatibility guidance,
            version details, screenshots, and user awareness. Alpha APK Store is
            not affiliated with the official developer, brand, or trademark owner
            unless clearly stated.
          </p>
          <p>
            Users should compare package name, permissions, developer details,
            and official sources before installing any third-party APK file.
          </p>
          {apk.official_url && (
            <p>
              <a href={apk.official_url} target="_blank" rel="noopener noreferrer">
                Visit Official Website →
              </a>
            </p>
          )}
          {apk.play_store_url && (
            <p>
              <a href={apk.play_store_url} target="_blank" rel="noopener noreferrer">
                View on Google Play Store →
              </a>
            </p>
          )}
        </div>
      )}

      <div className="whats-new-box">
        <h2>What is New in {cleanAppName}</h2>
        <p>
          {apk.whats_new ||
            "Improved Android compatibility, performance enhancements, stability fixes and bug improvements."}
        </p>
      </div>

      <div className="desc">
        <h2>About {cleanAppName}</h2>
        <p style={{ whiteSpace: "pre-line" }}>{formattedDescription}</p>
      </div>

      {selectedContent.sections.map((section, index) => (
        <div className="extra-section" key={index}>
          <h2>{section.title}</h2>
          <p>{section.text}</p>
        </div>
      ))}

      {selectedContent.features.length > 0 && (
        <div className="extra-section">
          <h2>Key Features of {cleanAppName}</h2>
          <ul>
            {selectedContent.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="extra-section">
        <h2>Why Choose {cleanAppName}?</h2>
        <p>
          {cleanAppName} provides {apk.category?.toLowerCase() || "utility"} features
          for Android users. This page includes verified package details, SHA256 hash,
          scan information, permission analysis, and compatibility notes to help you
          make an informed decision before downloading.
        </p>
      </div>

      <div className="extra-section">
        <h2>Who Should Use {cleanAppName}?</h2>
        <p>
          {cleanAppName} is suitable for Android users who need{" "}
          {apk.category?.toLowerCase() || "app"} functionality. Review the
          permissions, Android requirement, and file size to confirm compatibility
          with your device before installation.
        </p>
      </div>

      {alternativeApks.length > 0 && (
        <div className="alternatives-section">
          <h2>{cleanAppName} Alternatives</h2>
          <p>Users looking for similar apps can also explore these related options:</p>
          <ul className="alternatives-list">
            {alternativeApks.map((item) => {
              const cleanAltName =
                item.name
                  ?.replace(/APK Download Latest Version for Android Free/gi, "")
                  .replace(/APK Download Latest Version for Android/gi, "")
                  .replace(/APK Download for Android/gi, "")
                  .replace(/Download Latest Version for Android/gi, "")
                  .replace(/Latest Version/gi, "")
                  .replace(/Free/gi, "")
                  .replace(/APK/gi, "")
                  .replace(/\|/g, "")
                  .replace(/\s+/g, " ")
                  .trim() || item.name;

              const getCategoryEmoji = (cat) => {
                const c = cat?.toLowerCase() || "";
                if (c.includes("video")) return "🎬";
                if (c.includes("music")) return "🎵";
                if (c.includes("game")) return "🎮";
                if (c.includes("tool")) return "🔧";
                if (c.includes("vpn")) return "🔒";
                if (c.includes("browser")) return "🌐";
                if (c.includes("social")) return "💬";
                if (c.includes("photo")) return "📸";
                if (c.includes("file")) return "📁";
                if (c.includes("security")) return "🛡️";
                if (c.includes("education")) return "📚";
                return "📱";
              };

              return (
                <li key={item.slug}>
                  <Link to={`/apk/${item.slug}`} className="alternative-card">
                    <span className="alt-icon">{getCategoryEmoji(item.category)}</span>
                    <div className="alt-info">
                      <span className="alt-name">{cleanAltName}</span>
                      <span className="alt-tag">{item.category || "Android App"}</span>
                    </div>
                    <span className="alt-arrow">→</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      <div className="extra-section">
        <h2>How to Install {cleanAppName} APK</h2>
        <ol>
          {selectedContent.howToInstall.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ol>
      </div>

      <div className="pros-cons">
        <div className="pros-box">
          <h2>Advantages of {cleanAppName}</h2>
          <ul>
            {selectedContent.pros.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="cons-box">
          <h2>Things to Consider</h2>
          <ul>
            {selectedContent.cons.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="extra-section">
        <h2>{cleanAppName} Version Information</h2>
        <p>Current Version: {apk.version || "Latest"}</p>
        <p>Last Updated: {apk.updated_date || "Recently"}</p>
        <p>File Size: {apk.size || "N/A"}</p>
        <p>Category: {apk.category}</p>
        {apk.developer && <p>Developer: {apk.developer}</p>}
        {apk.package_name && <p>Package: {apk.package_name}</p>}
      </div>

      {/* Amazon Affiliate Product Card */}
      <AmazonProductCard category={apk.category} appName={cleanAppName} amazonData={apk.amazon_data} />

{/* PRIMARY DOWNLOAD BUTTON */}
<div id="download">
  {realDownloadUrl && (
    <a
      href={realDownloadUrl}
      className="primary-download-btn"
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      <span className="download-icon">⬇️</span>

      <div className="download-text">
        <strong>
          DOWNLOAD {cleanAppName.toUpperCase()} APK
        </strong>

        <span>
          {isHunarHub
            ? "Direct APK download from GitHub"
            : "Direct APK download"}
        </span>
      </div>
    </a>
  )}
</div>

{/* OTHER SOURCES */}
<div className="other-sources">
  <p className="sources-title">Other download sources</p>

  {apk.play_store_url && (
    <a
      href={apk.play_store_url}
      className="source-btn play-store"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="source-icon">▶️</span>
      <div className="source-text">
        <strong>Google Play Store</strong>
        <span>play.google.com • Official store</span>
      </div>
    </a>
  )}

  {(apk.github_url || isHunarHub) && (
    <a
      href={isHunarHub ? HUNARHUB_DOWNLOAD_URL : apk.github_url}
      className="source-card"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>🐙</span>

      <div>
        <strong>GitHub Releases</strong>
        <small>github.com • Official source</small>
      </div>
    </a>
  )}

  {apk.fdroid_url && (
    <a
      href={apk.fdroid_url}
      className="source-btn fdroid"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="source-icon">🤖</span>
      <div className="source-text">
        <strong>F-Droid</strong>
        <span>f-droid.org • App store</span>
      </div>
    </a>
  )}

  {apk.official_website_url && (
    <a
      href={apk.official_website_url}
      className="source-btn website"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="source-icon">🌐</span>
      <div className="source-text">
        <strong>Official Website</strong>
        <span>Official developer website</span>
      </div>
    </a>
  )}

  <div className="security-note">
    <p>
      🔒 Alpha APK Store does not host APK files. We verify app details and
      link to trusted official sources.
    </p>
  </div>
</div>

      {screenshotList.length > 0 && (
        <div className="screenshots">
          <h2>Screenshots</h2>
          <div className="ss-grid">
            {screenshotList.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${cleanAppName} Screenshot ${index + 1}`}
                loading="lazy"
                width="500"
                height="900"
              />
            ))}
          </div>
        </div>
      )}

      <div className="faq-box">
        <h2>Frequently Asked Questions</h2>
        {selectedContent.faq.map((item, index) => (
          <div className="faq-item" key={index}>
            <h3>{item.question}</h3>
            <p>{item.answer}</p>
          </div>
        ))}
      </div>

      <div className="safe-box">
        <div className="verified-badge">✓ Security Checked</div>
        <h2>Safe Download Notice</h2>
        <p>
          {apk.safety_note ||
            "Alpha APK Store verifies visible APK information before publishing. Users should always verify app permissions, package name, developer details, and Android requirements before installing any APK file. We recommend scanning downloaded files with your own antivirus software as an additional safety measure."}
        </p>
        <p>
          Alpha APK Store verifies package name, developer information, file size,
          permissions, Android requirement, screenshots, and update notes before
          listing an app page. We link only to official sources — Google Play Store,
          GitHub Releases, F-Droid, and verified developer websites.
        </p>
      </div>

      <div className="related" id="related-blogs">
        <h2>Helpful Android Guides</h2>
        <div className="related-grid">
          {relatedBlogs.map((post) => (
            <Link
              to={`/blog/${post.slug}`}
              className="related-card"
              key={post.slug}
            >
              <p>{post.category}</p>
              <h3>{post.title}</h3>
            </Link>
          ))}
        </div>
      </div>

      <div className="explore-more-box">
        <h2>Explore More Android Content</h2>
        <div className="explore-links-grid">
          <Link to={`/${apk.category?.toLowerCase()}`} className="explore-link-card">
            View More {apk.category} Apps
          </Link>
          <Link to="/blog" className="explore-link-card">
            Read Android Guides
          </Link>
          <Link to="/blog/safe-apk-download-guide" className="explore-link-card">
            APK Safety Guide
          </Link>
          <Link to="/blog/how-to-install-apk-files" className="explore-link-card">
            APK Installation Tutorial
          </Link>
        </div>
      </div>

      <div className="comments-box">
        <h2>User Comments</h2>
        {!commentUser ? (
          <p>Please login with Google to post comments.</p>
        ) : (
          <>
            <p className="author-line">Commenting as: {commentUser.email}</p>
            <textarea
              placeholder="Write your comment..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
            <button onClick={handleAddComment}>Post Comment</button>
          </>
        )}
        <div className="comments-list">
          {comments.length === 0 && (
            <p className="no-comments">
              No comments yet. Be the first to share your experience!
            </p>
          )}
          {comments.map((item) => (
            <div className="single-comment" key={item.id}>
              <strong>{item.user_name}</strong>
              <p>{item.comment}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="helpful-box">
        <h3>Was this page helpful?</h3>
        <button onClick={() => handleHelpful("yes")}>
          👍 Yes ({helpfulCount.yes})
        </button>
        <button onClick={() => handleHelpful("no")}>
          👎 No ({helpfulCount.no})
        </button>
      </div>

      <div className="report-box">
        <h3>Report an Issue</h3>
        <p>
          Found a broken download link, wrong app information, or a developer
          ownership concern? Tell Alpha APK Store so this page can be reviewed.
        </p>
        <a
          href={`mailto:alphaapkstore@gmail.com?subject=Report issue: ${encodeURIComponent(cleanAppName)}&body=App page: ${encodeURIComponent(pageUrl)}%0D%0AIssue:%20`}
          className="report-link"
        >
          Report Broken Link or Incorrect Information
        </a>
      </div>

      {finalRelatedApks.length > 0 && (
        <div className="related" id="related">
          <h2>Related Apps You May Like</h2>
          <div className="related-grid">
            {finalRelatedApks.map((app) => (
              <Link
                to={`/apk/${app.slug}`}
                className="related-card"
                key={app.id}
              >
                <img src={app.image_url} alt={app.name} />
                <p>{app.name}</p>
              </Link>
            ))}
          </div>
        </div>
      )}

      <footer className="pro-footer">
        <div className="footer-box">
          <div className="footer-left">
            <img
              src="/logo.png"
              alt="Alpha APK Store Logo"
              className="footer-logo"
            />
            <div className="footer-brand">
              <h2>ALPHA APK STORE</h2>
              <p>Safe APK downloads • Trusted updates • Fast access</p>
              <p>© 2026 Alpha APK Store. All Rights Reserved.</p>
              <p>Contact: alphaapkstore@gmail.com</p>
              <p>
                DMCA: We respect copyright owners and respond to valid removal
                requests.
              </p>
              <p>
                Disclaimer: Alpha APK Store does not claim ownership of
                third-party apps, logos, or trademarks.
              </p>
            </div>
          </div>
          <div className="footer-links">
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/security-trust">Security & Trust</Link>
            <Link to="/dmca">DMCA</Link>           
            <a
              href="https://www.youtube.com/@alphaapkstore"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube
            </a>
            <a
              href="https://pin.it/4iXPuvWFH"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pinterest
            </a>
            <a href="mailto:alphaapkstore@gmail.com">Email</a>
          </div>
        </div>
      </footer>
    </div>
  );
}